/* eslint-disable jsx-a11y/anchor-is-valid */
import {FC} from 'react'
import {ContractDashboardPage} from './pages/ContractDashboardPage'

export const ContractLayout: FC = () => <ContractDashboardPage />